export const hexToRGBA = (hex: string[6], alpha = 1) => {
  const R = parseInt(hex.slice(1, 3), 16)
  const G = parseInt(hex.slice(3, 5), 16)
  const B = parseInt(hex.slice(5, 7), 16)

  return `rgba(${R}, ${G}, ${B}, ${alpha})`
}
